module.exports = __webpack_public_path__ + "media/20240115-141801.fa214d3d.mp4";